// import { Dialog } from "@progress/kendo-react-dialogs";
import { useAudit } from "./auditContext";
import { Alert, AuditDialog } from "@mikros/shared-ui";
import {
  Box,
  createTheme,
  Dialog,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ThemeProvider,
} from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import ApiServices from "../../../service/apiService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { PerformanceAudit } from "../usersView/performaceAudit";
import { AuditHistory } from "../usersView/auditHistory";
import AuthService from "../../../service/authService";
import { jwtDecode } from "jwt-decode";

export function AuditDetails() {
  const {
    auditModel,
    setAuditModel,
    totalUserCount,
    setTotalUserCount,
    searchActive,
    setSearchActive,
    formData,
    setFormData,
    hasMoreData,
    setHasMoreData,
    auditNameSelected,
    setAuditNameSelected,
  } = useAudit();

  const theme = createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });

  const intl = useIntl();
  const childRef = useRef<any>();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [lastKey, setLastKey] = useState<any>("");
  const [auditorName, setAuditorName] = useState<string>("");

  const [sub, setSub] = useState(null);
  const subRef = useRef(null);

  const [perfAuditDialog, setPerfAuditDialog] = useState<boolean>(false);
  const [auditHistoryDialog, setAuditHistoryDialog] = useState<boolean>(false);
  const [perfAuditData, setPerfAuditData] = useState<any>();
  const [auditHistoryData, setAuditHistoryData] = useState<any>();

  const [newAuditData, setNewAuditData] = useState<any>();
  const [newAuditDialog, setNewAuditDialog] = useState<boolean>(false);

  const [selectedUserId, setSelectedUserId] = useState<string>();
  const [selectedAuditName, setSelectedAuditName] = useState<string>();

  console.log("print audit name selected", selectedAuditName);
  console.log("print audit name selected in audit details", auditNameSelected);
  console.log("Auditor name print", auditorName);
  console.log("has more data print",hasMoreData)

  const [employeeDetails, setEmployeeDetails] = useState({
    employeeName: "",
    auditName: "",
    branchName: "",
    userId: "",
    auditedBy: "",
  });

  const [employeeAuditDetails, setEmployeeAuditDetails] = useState({
    employeeName: "",
    auditName: "",
    department: "",
    designation: "",
    location: "",
    branch: "",
  });

  const togglePerfAuditDialog = () => {
    console.log("clicked audit create new dialog", perfAuditDialog);
    setPerfAuditDialog(true);
  };
  const toggleAuditHistoryDialog = () => {
    console.log("clicked audit history dialog", auditHistoryDialog);
    setAuditHistoryDialog(true);
  };

  const handleAuditSubmit = (auditData: any) => {
    console.log("Received audit data from child:", auditData);
    setFormData(auditData);
  };

  const navigate = useNavigate();

  const paginatedData = searchActive
    ? rowsPerPage === -1
      ? auditModel?.audits
      : auditModel?.audits?.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )
    : rowsPerPage === -1
    ? auditModel?.audits
    : auditModel?.audits?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
  const totalPages =
    auditModel.audits?.length > 0
      ? Math.ceil(auditModel.audits?.length / rowsPerPage)
      : 1;

  console.log("audit model data print in audit details", auditModel);

  const dateFormatFunc = (dateString: string) => {
    if (!dateString) {
      return intl.formatMessage({ id: "naValue" });
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); //ensures 2  digit day
    const months = [
      intl.formatMessage({ id: "janValue" }),
      intl.formatMessage({ id: "febValue" }),
      intl.formatMessage({ id: "marValue" }),
      intl.formatMessage({ id: "aprValue" }),
      intl.formatMessage({ id: "mayValue" }),
      intl.formatMessage({ id: "junValue" }),
      intl.formatMessage({ id: "julValue" }),
      intl.formatMessage({ id: "augValue" }),
      intl.formatMessage({ id: "septValue" }),
      intl.formatMessage({ id: "octValue" }),
      intl.formatMessage({ id: "novValue" }),
      intl.formatMessage({ id: "decValue" }),
    ];
    const month = months[date.getMonth()]; // Get the month name

    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    //format time as hh:mm AM/PM (local time without seconds)
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm =
      hours >= 12
        ? intl.formatMessage({ id: "pmValue" })
        : intl.formatMessage({ id: "amValue" });
    hours = hours % 12; // to convert 24-format to 12-hour format
    hours = hours ? hours : 12; //to handle 0 hour
    const formattedTime = `${hours}:${minutes} ${ampm}`;
    // return `${formattedDate} at ${formattedTime}`;
    return `${formattedDate}`;
  };
  const handleChangePage = async (event: any, newPage: number) => {
    setPage(newPage - 1);
    console.log("click of handle change page");

    if (!loading && !searchActive) {
      if (hasMoreData) {
        fetchAudits(rowsPerPage, lastKey);
      }
    }
  };

  const handleRowsPerPageChange = (event: { target: { value: string } }) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log("Rows per page change value:", newRowsPerPage);

    setRowsPerPage(newRowsPerPage);

    if (!searchActive) {
      setFormData({
        auditName: "",
        auditedBy: "",
        branchName: "",
        department: "",
        location: "",
        designation: "",
        email: "",
        phNo: "",
      });

      setPage(0); // Reset to first page
      setLastKey(null); // Reset pagination key
      setSearchActive(false);
      setAuditModel({ audits: [] }); // Clear previous user data

      fetchAudits(newRowsPerPage, ""); // Use newRowsPerPage directly
    }
  };

  function fetchAudits(limit: number, key: string) {
    if (searchActive) {
      console.log("inside fetch audits");
      setFormData({
        auditName: "",
        auditedBy: "",
        branchName: "",
        department: "",
        location: "",
        designation: "",
        email: "",
        phNo: "",
      });
    }

    let api = ApiServices.getInstance();
    if (limit === -1) {
      setLoading(true);
      console.log("inside limit equal -1");
      api
        .makeRequest(`${accountInstance.accntId}/useraudit`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("entered error code handling in user details");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            setAuditModel(data);
            const totalUserCount = data?.audits.length;
            setTotalUserCount(totalUserCount);
            setLoading(false);
            if (hasMoreData) {
              setHasMoreData(!!data?.lastKey);
            }
          }
        });
      return;
    }
    if (accountInstance.accntId && key === "") {
      setLoading(true);

      console.log("entered when last key is null");
      api
        .makeRequest(`${accountInstance.accntId}/useraudit?limit=20`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            setAuditModel(data);
            const totalUserCount = data?.audits?.length;
            setTotalUserCount(totalUserCount);
            setLastKey(data.lastKey);
            // props.hasMoreDataReference.current = !!data?.lastKey;
            console.log("data last key when limit 20", data?.lastKey);
            if (hasMoreData) {
              setHasMoreData(!!data?.lastKey);
            }
            setLoading(false);
          }
        });
    }

    //need to check if correct// because duplicated maybe present
    else if (accountInstance.accntId && key !== null) {
      setLoading(true);
      console.log("Fetching next page with lastKey:", key);
      api
        .makeRequest(
          `${accountInstance.accntId}/useraudit?limit=${limit}&lastKey=${key}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is not null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data?.errorMessage);
            return;
          } else {
            // Append only when paginating
            setAuditModel((prevData: any) => ({
              ...prevData,
              users: [...prevData?.audits, ...data?.audits],
            }));
            setTotalUserCount(data?.audits?.length || 0);

            setLastKey(data.lastKey);
            console.log("data last key when last key not null", data?.lastKey);

            // props.hasMoreDataReference.current = !!data?.lastKey;
            if (hasMoreData) {
              setHasMoreData(!!data?.lastKey);
            }
            setLoading(false);
            // setFetchedDataBefore(true); // Prevent unnecessary re-fetching
          }
        });
    }
  }
  useEffect(() => {
    console.log("inside use effect where I am fetching data");

    fetchAudits(rowsPerPage, lastKey);
  }, [accountInstance.accntId]);
  useEffect(() => {
    if (page >= totalPages) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [totalPages, page]);

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect", subValue);
    }
    fetchSub();
  }, []);

  useEffect(() => {
    if (subRef.current !== null) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/audit/auditnames?userId=${subRef.current}`,
            "GET"
          )
          .then(async (data) => {
            if (data && data.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
            } else {
              setAuditorName(data.userName);
            }
          });
      }
    }
  }, [subRef.current]);

  // Your existing component logic here
  return (
    <div>
      {errorFlag && (
        <Dialog open={true} className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                navigate("/audit");
              }
            }}
          />
        </Dialog>
      )}

      {perfAuditDialog && (
        <Dialog
          PaperProps={{
            style: {
              width: "80vw",
              height: "90vh",
              maxWidth: "90vw", // Override Material UI's default max width
              maxHeight: "90vh", //
              borderRadius: "10px",
              paddingTop: "16px", // equivalent to pt-4
              padding: "20px",
              boxSizing: "border-box",
            },
          }}
          open={true}
          onClose={() => setPerfAuditDialog(false)}
        >
          <AuditDialog
            component={() => (
              <PerformanceAudit
                ref={childRef}
                employeeDetails={employeeDetails}
                auditFormData={formData}
                userAuditData={auditModel}
                auditFormDataFunction={setFormData}
                auditDialogToggle={setPerfAuditDialog}
                auditDialogValue={perfAuditDialog}
                dataGridItems={perfAuditData}
                submitAudit={handleAuditSubmit}
                // triggerFetchFunction={setTriggerFetch}
                onReload={() => fetchAudits(rowsPerPage, "")}
              ></PerformanceAudit>
            )}
          />
        </Dialog>
      )}

      {auditHistoryDialog && (
        <Dialog
          PaperProps={{
            style: {
              width: "70vw",
              height: "70vh",
              maxWidth: "70vw", // Override Material UI's default max width
              maxHeight: "70vh", //
              borderRadius: "10px",
              paddingTop: "16px", // equivalent to pt-4
              padding: "20px",
              boxSizing: "border-box",
            },
          }}
          open={true}
          onClose={() => setPerfAuditDialog(false)}
        >
          <AuditDialog
            component={() => (
              <AuditHistory
                ref={childRef}
                employeeAuditHistDetails={employeeAuditDetails}
                auditDialogToggle={setAuditHistoryDialog}
                auditDialogValue={auditHistoryData}
                dataGridItems={auditHistoryData}
                userId={selectedUserId!!}
                auditName={selectedAuditName!!}
              ></AuditHistory>
            )}
          />
        </Dialog>
      )}

      <div className="pb-[2%]"></div>
      <TableContainer
        component={Paper}
        style={{
          overflowX: "auto",
          width: "100%",
          backgroundColor: "var(--color-mk-primary-10) !important",
        }}
        elevation={0}
      >
        <Table
          sx={{
            width: "100%",
            tableLayout: "auto",
          }}
          size="medium"
        >
          <TableHead>
            <TableRow
              sx={{
                "&:hover": {
                  backgroundColor: "var(--color-mk-primary-10) !important",
                },
                "& th": {
                  borderBottom: "none",
                },
              }}
            >
              <TableCell style={{ width: "14%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.userName" />
              </TableCell>
              <TableCell style={{ width: "14%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.auditName" />
              </TableCell>
              <TableCell style={{ width: "12%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.department" />
              </TableCell>
              <TableCell style={{ width: "12%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.branch" />
              </TableCell>
              <TableCell style={{ width: "12%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.location" />
              </TableCell>
              <TableCell style={{ width: "12%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.designation" />
              </TableCell>
              <TableCell style={{ width: "12%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.lastAuditDate" />
              </TableCell>
              <TableCell style={{ width: "8%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.auditedBy" />
              </TableCell>
              <TableCell style={{ width: "4%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.userAuditView.score" />
              </TableCell>
              <TableCell style={{ width: "4%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="audit.auditDetails.trending" />
              </TableCell>
              <TableCell width="2%" align="right" />
              <TableCell width="2%" align="right" />
            </TableRow>
          </TableHead>
          {/* Rest of the table body remains unchanged */}
          {auditNameSelected !== "" && searchActive ? (
            <TableBody>
              {paginatedData?.length > 0 ? (
                paginatedData?.map(
                  (
                    audit: {
                      username: string;
                      auditName: string;
                      department: string;
                      location: string;
                      branchName: string;
                      designation: string;
                      auditDate: string;
                      auditedBy: string;
                      scorePercentage: number;
                      trending: string;
                      gender: string;
                      userId: string;
                    },
                    index: any
                  ) => (
                    <TableRow
                      sx={{
                        backgroundColor:
                          "var(--color-mk-primary-20) !important",
                        "&:hover": {
                          backgroundColor:
                            "var(--color-mk-primary-20) !important",
                        },
                      }}
                    >
                      <TableCell>{audit?.username}</TableCell>
                      <TableCell>{audit?.auditName}</TableCell>
                      <TableCell>{audit?.department}</TableCell>
                      <TableCell>{audit?.branchName}</TableCell>
                      <TableCell>{audit?.location}</TableCell>
                      <TableCell>{audit?.designation}</TableCell>
                      <TableCell>{dateFormatFunc(audit.auditDate)}</TableCell>
                      <TableCell>{audit?.auditedBy}</TableCell>
                      <TableCell>{audit?.scorePercentage}%</TableCell>
                      <TableCell>
                        {audit.trending === "UP" ? (
                          <FontAwesomeIcon
                            icon={["fas", "fa-arrow-trend-up" as IconName]}
                            className="h-5 w-5 mx-3 hover:cursor-pointer text-mk-bright-green"
                          />
                        ) : audit.trending === "DOWN" ? (
                          <FontAwesomeIcon
                            icon={["fas", "fa-arrow-trend-down" as IconName]}
                            className="h-5 w-5 mx-3 hover:cursor-pointer text-mk-red"
                          />
                        ) : audit.trending === "NEUTRAL" ? (
                          <div>
                            <FormattedMessage id="userAuditDetails.neutral" />
                          </div>
                        ) : null}
                      </TableCell>
                      <TableCell align="right">
                        <Box
                          src={"/notebookEye.svg"}
                          component="img"
                          onClick={() => {
                            setSelectedUserId(audit.userId);
                            setSelectedAuditName(audit.auditName);
                            toggleAuditHistoryDialog();
                            setAuditHistoryData(audit);
                            setEmployeeAuditDetails({
                              employeeName: audit.username,
                              auditName: audit.auditName,
                              department: audit.department,
                              designation: audit.designation,
                              location: audit.location,
                              branch: audit.branchName,
                            });
                          }}
                          sx={{
                            cursor: "pointer",
                            width: 16,
                            height: 16,
                            minWidth: 16,
                            minHeight: 16,
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Box
                          component="img"
                          src={"/createNew.svg"}
                          onClick={() => {
                            togglePerfAuditDialog();
                            setPerfAuditData(audit);
                            setEmployeeDetails({
                              employeeName: audit.username,
                              auditName: audit.auditName,
                              branchName: audit.branchName,
                              userId: audit.userId,
                              auditedBy:
                                audit.auditedBy === auditorName
                                  ? audit.auditedBy
                                  : auditorName,
                            });
                          }}
                          sx={{
                            cursor: "pointer",
                            width: 16,
                            height: 16,
                            minWidth: 16,
                            minHeight: 16,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                      <FormattedMessage id="users.addNewUser.noUser" />
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          ) : (
            <TableBody>
              <TableCell colSpan={12} align="center">
                <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                  <FormattedMessage id="audit.auditDetails.selectAuditName" />
                </div>
              </TableCell>
            </TableBody>
          )}
        </Table>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            backgroundColor: "var(--color-mk-primary-10) !important",
            padding: 0,
          }}
        >
          {auditNameSelected !== "" && searchActive && (
            <Box display="flex" justifyContent="center" alignItems="center">
              <ThemeProvider theme={theme}>
                <Pagination
                  count={totalPages}
                  page={page + 1}
                  onChange={handleChangePage}
                  variant="text"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  siblingCount={1}
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      disabled={
                        (item.type === "next" &&
                          !hasMoreData &&
                          page === totalPages - 1) ||
                        ((item.type === "previous" || item.type === "first") &&
                          page === 0) ||
                        (item.type === "last" &&
                          !hasMoreData &&
                          page === totalPages - 1)
                      }
                    />
                  )}
                />
              </ThemeProvider>

              <TablePagination
                rowsPerPageOptions={[
                  5,
                  10,
                  15,
                  25,
                  { label: intl.formatMessage({ id: "allValue" }), value: -1 },
                ]}
                component="div"
                count={totalUserCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(event, newPage) => setPage(newPage)}
                onRowsPerPageChange={handleRowsPerPageChange}
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} ${intl.formatMessage({
                    id: "ofValue",
                  })} ${count} ${intl.formatMessage({ id: "items" })}`
                }
                ActionsComponent={() => null}
                sx={{
                  color: "#6464E5",
                }}
              />
            </Box>
          )}
        </Stack>
      </TableContainer>

      <div className="pb-[10%]"></div>
    </div>
  );
}
